import { jwtDecode } from 'jwt-decode';

export default {
	verifyToken(token){
		try {
			const decoded = jwtDecode(token);
			const currentTime = Math.floor(Date.now() / 1000);
			
			if (decoded.exp && decoded.exp < currentTime) {
				return { error: true, msg: 'Token expirado' };
			}
			
			return decoded;
		} catch(err) {
			return { error: true, msg: 'Token inválido' };
		}
	},
};